var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogledrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 741.3696,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 168,
    height: 154,
    x: 12,
    y: 18,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.09 37c14.626-25.333 51.193-25.334 65.819 0l45.033 78c14.626 25.334-3.657 57.001-32.91 57.001H50.967c-29.253 0-47.536-31.667-32.91-57.001Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    transform: "matrix(4.8140532,0,0,4.8140532,-62.146701,-86.652356)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M206.905 172.02h-91.888l-19.015-32.934 45.944-79.578Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M-14.919 172.006 50.04 59.494v.002L31.032 92.422h38.02L115 172.004l-129.918.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M96.007-20.085 141.954 59.5l-19.011 32.928H31.048Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 193.6,
    x2: 103.09,
    y1: 165.6,
    y2: 111.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffe921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 114.4,
    x2: 15.53,
    y1: 181.61,
    y2: 121.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a9a8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6d97ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3186ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 128.88,
    x2: 28.7,
    y1: 37.88,
    y2: 84.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0ebc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#78c9ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogledrive);
export default __webpack_public_path__ + "static/media/googledrive.a08a0dbb164e83731ddb0ad5526e5ea4.svg";
export { ForwardRef as ReactComponent };